/**
 * Trava do botão "Adicionar ao carrinho" enquanto o box "Personalize seu
 * produto" não estiver completo (iniciais + cor, nome a laser + fonte,
 * "Não quero personalizar" etc.).
 *
 * Motivo: ao trocar a variante, o product-info.js do Dawn reabilita o botão
 * com base apenas na disponibilidade da variante, ignorando a regra da
 * personalização.
 *
 * Este script só DESABILITA. Quem habilita continua sendo o
 * product-kit-customize.js (e o Dawn), evitando conflito entre eles.
 */
(function () {
  if (window.__kcGateLoaded) return;
  window.__kcGateLoaded = true;

  const initialized = new Set();

  function setupGate(formId) {
    if (!formId || initialized.has(formId)) return;
    initialized.add(formId);

    const getGate = () =>
      document.querySelector(`[data-kc-gate][data-form-id="${formId}"]`);

    const getButton = () => {
      const form = document.getElementById(formId);
      return form ? form.querySelector('[name="add"], button[type="submit"]') : null;
    };

    // Regra: delega ao próprio componente, para que as duas travas nunca
    // divirjam (antes só aceitava checkbox e bloqueava o fluxo de iniciais).
    const isChoiceMade = () => {
      const gate = getGate();
      const customizer = gate && gate.querySelector('product-kit-customize');
      if (!customizer) return true; // produto sem o box: não trava nada
      // Componente ainda não inicializado: mantém travado até o connectedCallback
      if (typeof customizer.isComplete !== 'function') return false;
      return customizer.isComplete();
    };

    const enforce = () => {
      const button = getButton();
      if (button && !button.disabled && !isChoiceMade()) {
        button.setAttribute('disabled', 'disabled');
      }
    };

    // Reage quando o Dawn reabilita o botão ou troca o HTML dele
    // após a mudança de variante.
    new MutationObserver(enforce).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });

    // Segunda camada: impede o envio mesmo que o botão seja ativado
    // por outro caminho. Roda em captura, antes do product-form.js.
    document.addEventListener(
      'submit',
      (event) => {
        if (event.target.id !== formId || isChoiceMade()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const gate = getGate();
        if (gate) gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );

    enforce();
  }

  function initAll() {
    document
      .querySelectorAll('[data-kc-gate]')
      .forEach((el) => setupGate(el.dataset.formId));
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();